export enum teacherTypes {
  PEDAGOGUE = 'pedagogue',
  HELP = 'helpTeacher',
  PRIMARY = 'primaryTeacher',
  SUBSTITUTE = 'substituteTeacher',
}
